// extracted by mini-css-extract-plugin
module.exports = {"order-patient-message-table":"order-patient-message-table-3111a94dd6a5eb9b48856ad150c334cf"};